import { useEffect } from 'react';
import useBranding from 'hooks/useBranding';

/**
 * Applies white-label branding from localStorage to the DOM:
 * - CSS custom properties (--brand-primary, --brand-dark) for dynamic theming
 * - document.title for the browser tab name
 * - favicon href if a custom favicon URL is stored
 */
const BrandingProvider = ({ children }) => {
    const branding = useBranding();

    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--brand-primary', branding.primaryColor);
        root.style.setProperty('--brand-dark', branding.darkColor);

        // Derive lighter tints used in hover states, backgrounds, etc.
        root.style.setProperty('--brand-primary-light', branding.primaryColor + '18');
        root.style.setProperty('--brand-primary-border', branding.primaryColor + '40');
    }, [branding.primaryColor, branding.darkColor]);

    useEffect(() => {
        document.title = branding.productName;
    }, [branding.productName]);

    useEffect(() => {
        if (!branding.faviconUrl) return;
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        link.href = branding.faviconUrl;
    }, [branding.faviconUrl]);

    return children;
};

export default BrandingProvider;
